export enum NotificationLines {
  MULTI = 'multi',
  SINGLE = 'single',
}
